import React from 'react';
import { ImageCol } from '@/components/ImageCol';
import {
    ImageContentCol,
    IMAGE_CONTENT_COL_SPACING
} from '@/components/ImageContentCol';
import RenderDotPoints from '@/components/RenderDotPoints';
import RenderParagraphs from '@/components/RenderParagraphs';
import { useTranslationHook } from '@/hooks/useTranslationHook';
import './styles.scss';

const AccountingSection = () => {
    const { translate } = useTranslationHook();

    return (
        <div className='mt-4' id='top'>
            <ImageContentCol title={translate('accountingFinancialTitle')}
                             spacing={IMAGE_CONTENT_COL_SPACING.NONE}
                             leftContent={
                                 <>
                                     <RenderParagraphs translateLabel='accountingFinancialParagraphs'/>
                                     <h5>{translate('accountingFinancialSubTitle')}</h5>
                                     <RenderDotPoints translateLabel='accountingFinancialItemList'/>
                                 </>
                             }
                             rightContent={
                                 <div className='job-seeker-image'>
                                     <ImageCol src={'core-staff-accounting-2.png'}
                                               alt={'standing-workers'}/>
                                 </div>
                             }
            />

        </div>
    );
};

export default AccountingSection;